export const atLeastOneDigit = /^(.*?[0-9]){1,}.*$/;
